var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
var emptyIndent = 'margin:0;';
var getColor = function (_a) {
    var _b = _a.$color, $color = _b === void 0 ? 'TextPrimary' : _b;
    return COLORS[$color];
};
/**
 * Desktop: 56/68
 * Mobile: 32/40
 */
export var H1 = styled.h1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: ", ";\n    ", "\n    \n    color: ", ";\n\n    ", ";\n\n    @media (min-width: ", ") {\n        ", "\n        ", ";\n    }\n"], ["\n    width: ", ";\n    ", "\n    \n    color: ", ";\n\n    ", ";\n\n    @media (min-width: ", ") {\n        ", "\n        ", ";\n    }\n"])), function (_a) {
    var _b = _a.$inline, $inline = _b === void 0 ? false : _b;
    return $inline ? 'auto' : '100%';
}, function (_a) {
    var _b = _a.$withIndent, $withIndent = _b === void 0 ? true : _b;
    return $withIndent ? 'margin: 0 0 24px;' : emptyIndent;
}, getColor, function (_a) {
    var $desktop = _a.$desktop;
    return $desktop ? FONTS.H0 : FONTS.H2;
}, wideBreakpoints.mobile, function (_a) {
    var _b = _a.$withIndent, $withIndent = _b === void 0 ? true : _b;
    return $withIndent ? 'margin-bottom: 56px;' : emptyIndent;
}, function (_a) {
    var $mobile = _a.$mobile;
    return $mobile ? FONTS.H2 : FONTS.H0;
});
/**
 * Desktop: 40/52, $smaller: 32/40
 * Mobile: 24/32
 */
export var H2 = styled.h2(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: ", ";\n    ", "\n    \n    color: ", ";\n\n    ", ";\n\n    @media (min-width: ", ") {\n        ", ";\n    }\n"], ["\n    width: ", ";\n    ", "\n    \n    color: ", ";\n\n    ", ";\n\n    @media (min-width: ", ") {\n        ", ";\n    }\n"])), function (_a) {
    var _b = _a.$inline, $inline = _b === void 0 ? false : _b;
    return $inline ? 'auto' : '100%';
}, function (_a) {
    var _b = _a.$withIndent, $withIndent = _b === void 0 ? true : _b;
    return $withIndent ? 'margin: 0 0 24px;' : emptyIndent;
}, getColor, function (_a) {
    var $desktop = _a.$desktop, $smaller = _a.$smaller;
    return $desktop ? $smaller ? FONTS.H2 : FONTS.H1 : FONTS.H3;
}, wideBreakpoints.mobile, function (_a) {
    var $mobile = _a.$mobile, _b = _a.$smaller, $smaller = _b === void 0 ? false : _b;
    return $mobile ? FONTS.H3 : $smaller ? FONTS.H2 : FONTS.H1;
});
/**
 * Desktop: 24/32
 * Mobile: 20/28
 */
export var H3 = styled.h3(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: ", ";\n    ", "\n\n    color: ", ";\n\n    ", ";\n\n    @media (min-width: ", ") {\n        ", ";\n        ", "\n    }\n"], ["\n    width: ", ";\n    ", "\n\n    color: ", ";\n\n    ", ";\n\n    @media (min-width: ", ") {\n        ", ";\n        ", "\n    }\n"])), function (_a) {
    var _b = _a.$inline, $inline = _b === void 0 ? false : _b;
    return $inline ? 'auto' : '100%';
}, function (_a) {
    var _b = _a.$withIndent, $withIndent = _b === void 0 ? true : _b;
    return $withIndent ? 'margin: 0 0 16px;' : emptyIndent;
}, getColor, function (_a) {
    var $desktop = _a.$desktop;
    return $desktop ? FONTS.H3 : FONTS.H4;
}, wideBreakpoints.mobile, function (_a) {
    var $mobile = _a.$mobile;
    return $mobile ? FONTS.H4 : FONTS.H3;
}, function (_a) {
    var _b = _a.$withIndent, $withIndent = _b === void 0 ? true : _b;
    return $withIndent ? 'margin: 0 0 24px;' : emptyIndent;
});
/**
 * Desktop: 20/28, $smaller: 16/24
 * Mobile: 16/24
 */
export var H4 = styled.h4(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: ", ";\n    ", "\n\n    color: ", ";\n\n    ", ";\n\n    @media (min-width: ", ") {\n        ", ";\n    }\n"], ["\n    width: ", ";\n    ", "\n\n    color: ", ";\n\n    ", ";\n\n    @media (min-width: ", ") {\n        ", ";\n    }\n"])), function (_a) {
    var _b = _a.$inline, $inline = _b === void 0 ? false : _b;
    return $inline ? 'auto' : '100%';
}, function (_a) {
    var _b = _a.$withIndent, $withIndent = _b === void 0 ? true : _b;
    return $withIndent ? 'margin: 0 0 16px;' : emptyIndent;
}, getColor, function (_a) {
    var $desktop = _a.$desktop, $smaller = _a.$smaller;
    return $desktop ? $smaller ? FONTS.H5 : FONTS.H4 : FONTS.H5;
}, wideBreakpoints.mobile, function (_a) {
    var $mobile = _a.$mobile, _b = _a.$smaller, $smaller = _b === void 0 ? false : _b;
    return $smaller || $mobile ? FONTS.H5 : FONTS.H4;
});
/**
 * All: 14/20
 */
export var H5 = styled.h5(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    width: ", ";\n    ", "\n\n    color: ", ";\n\n    ", ";\n"], ["\n    width: ", ";\n    ", "\n\n    color: ", ";\n\n    ", ";\n"])), function (_a) {
    var _b = _a.$inline, $inline = _b === void 0 ? false : _b;
    return $inline ? 'auto' : '100%';
}, function (_a) {
    var _b = _a.$withIndent, $withIndent = _b === void 0 ? true : _b;
    return $withIndent ? 'margin: 0 0 16px;' : emptyIndent;
}, getColor, FONTS.H6);
/**
 * @deprecated
 */
export var H6 = styled.h6(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    width: ", ";\n\n    color: ", ";\n\n    ", ";\n\n    text-transform: uppercase;\n"], ["\n    width: ", ";\n\n    color: ", ";\n\n    ", ";\n\n    text-transform: uppercase;\n"])), function (_a) {
    var _b = _a.$inline, $inline = _b === void 0 ? false : _b;
    return $inline ? 'auto' : '100%';
}, getColor, FONTS.LABEL);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
